import type { ReactNode } from "react";
import type { DashboardWidgetId } from "./types";
import { BusinessQuickActionsWidget, BusinessStatsWidget, BusinessSystemOverviewWidget, type BusinessWidgetData } from "./widgets/business-widgets";
import { ChefExperienceWidget } from "./widgets/chef-experience-widget";
import { ManagerRecipeOverviewWidget } from "./widgets/manager-recipe-overview-widget";

interface DashboardWidgetContext {
  businessData?: BusinessWidgetData;
}

type WidgetRender = (context: DashboardWidgetContext) => ReactNode;

const WIDGET_REGISTRY: Record<DashboardWidgetId, WidgetRender> = {
  BUSINESS_STATS: (context) => {
    if (!context.businessData) return null;
    return <BusinessStatsWidget data={context.businessData} />;
  },
  BUSINESS_QUICK_ACTIONS: (context) => {
    if (!context.businessData) return null;
    return <BusinessQuickActionsWidget data={context.businessData} />;
  },
  BUSINESS_SYSTEM_OVERVIEW: (context) => {
    if (!context.businessData) return null;
    return <BusinessSystemOverviewWidget data={context.businessData} />;
  },
  MANAGER_RECIPE_OVERVIEW: () => <ManagerRecipeOverviewWidget />,
  CHEF_EXPERIENCE: () => <ChefExperienceWidget />,
};

export function renderDashboardWidget(widgetId: DashboardWidgetId, context: DashboardWidgetContext) {
  return WIDGET_REGISTRY[widgetId](context);
}
